module.exports = __webpack_public_path__ + "media/images/logo__torquegc-396de6228a904de626dbb1349ac59707.png";